export default __webpack_public_path__ + "files/media/brand-new-logo.337477c0.svg";